// Modules object for setting up the Quill editor
export const modules = { toolbar: { container: "#toolbar" } };

// Quill Toolbar component
export const Toolbar = ({ formats1, formats2, colours, link, reset }) => (
  <div id="toolbar">
    {formats1 && (
      <span className="ql-formats">
        <button className="ql-bold" title="Bold" />
        <button className="ql-italic" title="Italic" />
        <button className="ql-underline" title="Underline" />
        <button className="ql-strike" title="Strikethrough" />
      </span>
    )}
    {formats2 && (
      <span className="ql-formats">
        <button className="ql-script" value="super" title="Superscript" />
        <button className="ql-script" value="sub" title="Subscript" />
      </span>
    )}
    {colours && (
      <span className="ql-formats">
        <select className="ql-color" title="Font Color" />
        <select className="ql-background" title="Background Color" />
      </span>
    )}
    {link && (
      <span className="ql-formats">
        <button className="ql-link" title="Add Link" />
      </span>
    )}
    {reset && (
      <span className="ql-formats">
        <button className="ql-clean" title="Reset" />
      </span>
    )}
  </div>
);

export default Toolbar;
